import { withInstall } from '@hongluan-ui/utils'
import Container from '../layout/src/container.vue'

export const HlContainer = withInstall(Container)
export default HlContainer
